firebird.directive('mobileHyperlink', [
    '$compile',
    'meetingService',
    function ($compile, meetingService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (attrs.mobileHyperlink === 'false') {
                    return;
                }

                //By the time we receive the param 'filteredText', it will already have been
                //filtered by linky, so it will either be a hyperlink or normal text
                scope.$watch(attrs.ngBindHtml, function (filteredText) {
                    //angular.element will wrap text with jQuery
                    var wrappedElement = angular.element(filteredText);

                    //If non-HTML (just normal text),
                    //the wrappedElement will be an empty array
                    if (wrappedElement.length === 0) {
                        return;
                    }

                    //If its a URL, linky will return <a href="some-url.com"></a>
                    //jQuery's .is() function lets us check if the element has that anchor tag
                    if (wrappedElement.is('a')) {
                        var url = wrappedElement.attr('href'),
                            text = wrappedElement.html(),
                            //Idea: create a dummy anchor tag and apply
                            //an onClick listener to evoke mobile's native browser
                            newElement = '<a href="#">' + text + '</a>';

                        //'element' is a reference to the span around the the message text.
                        //Here we are replacing that message text with our dummy anchor tag
                        element.html(newElement);

                        //Recompile that span element so that the DOM now has
                        //the dummy anchor tag
                        $compile(element.contents())(scope);

                        //Add an event listner to the dummy anchor tag
                        element.find('a').on('click', function () {
                            meetingService.openExternalLink(url);
                        });
                    }
                });
            }
        };
    }
]);
